<mat-menu #appMenu="matMenu" [overlapTrigger]="false">
  <ng-content select="app-menu-content"></ng-content>
</mat-menu>
<button mat-icon-button [matMenuTriggerFor]="appMenu">
  <ng-content></ng-content>
</button>
